import React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  DatePicker,
  type DatePickerProps,
} from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import translate from '@/lib/intl/translate';

export type DateInputProps = Omit<
  DatePickerProps<Date, Date>,
  'renderInput' | 'value'
> & {
  classes?: {
    root?: string;
  };
  error?: boolean;
  helperText?: string;
  id?: string;
  onChange?: (value: Date, keyboardInputValue?: string | undefined) => void;
  required?: boolean;
  value?: Date | null;
};

const DateInput = React.forwardRef(
  (
    {
      disabled = false,
      error = false,
      helperText = '',
      id,
      required = false,
      ...props
    }: DateInputProps,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => (
    <div className={props?.classes?.root}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          {...props}
          readOnly={disabled}
          inputRef={ref}
          value={props.value || null}
          renderInput={(params) => (
            <TextField
              {...params}
              {...(error || params.error
                ? {
                    error: true,
                    helperText: helperText?.length
                      ? helperText
                      : translate('INVALID_DATE_FORMAT_MESSAGE'),
                  }
                : { error: false })}
              data-testid={id}
              disabled={disabled}
              fullWidth
              required={required}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  ),
);

export default DateInput;
